import icon from "images/icons/icon-public.svg"

export default function PublicIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
